import styled from 'styled-components';

import TH from './TH';
import TD from './TD';
import TR from './TR';

const Table = styled.table`
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
  border: 1px solid #e9ecef;
  border-collapse: collapse;
  margin-top: 1rem
`;

export {
  TH,
  TD,
  TR,
  Table,
};



// WEBPACK FOOTER //
// ./app/components/Table/index.js